import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

import { BASIC_ANIMATION_VARIANTS } from "../../../utils/constants";
import { MinusIcon, CheckIcon } from "@heroicons/react/solid";
import { ReactComponent as Circle } from "../../../assets/images/ellipse-outline.svg";

function CheckBoxCard(props) {
    const { listItem, onChange, type, checked } = props;

    const [selected, setSelected] = useState(false);

    useEffect(() => {
        setSelected(checked);
    }, [checked]);

    return (
        <div className={
            "flex inline-flex items-center justify-center md:justify-start p-3 rounded-lg active:bg-primary-50 cursor-pointer transition-all " +
            (selected ? type === "current" ? "bg-red-50 " : "bg-green-50" : "bg-blue-gray-100 ")
        }
        >
            <div
                id={listItem.userIdentifier ? listItem.userIdentifier : listItem.code ? listItem.code : listItem.name ? listItem.name : listItem}
                onClick={(event) => {
                    setSelected(selected => !selected);
                    onChange(event, type);
                }}
                className={"absolute h-16 w-64 cursor-pointer"}
            />
            <AnimatePresence>

                {selected ?
                    <motion.div
                        initial={"inactive"}
                        animate={"active"}
                        exit={"inactive"}
                        transition={{ duration: .4 }}
                        variants={BASIC_ANIMATION_VARIANTS}
                    >
                        {type === "current" ?

                            <MinusIcon className="block h-4 w-4 text-red-500" />
                            :

                            <CheckIcon className="block h-4 w-4 text-green-500" />}
                    </motion.div>
                    :
                    <Circle className="block h-4 w-4 text-blue-gray-500" />
                }

            </AnimatePresence>
            <label
                htmlFor={listItem.name ? listItem.name : listItem}
                className="ml-3 text-sm cursor-default"
                aria-hidden="true"
            >
                <div className="flex items-center">
                    <div>
                        <div className="text-sm font-medium text-blue-gray-900">
                            {listItem.name ? listItem.name : listItem}
                        </div>

                        {listItem.emailAddress &&
                            <div className="text-sm text-blue-gray-500 mt-1">
                                {listItem.emailAddress}
                            </div>
                        }

                        {listItem.applicationName &&
                            <div className="text-sm text-blue-gray-500 mt-1">
                                {listItem.applicationName}
                            </div>
                        }

                        {listItem.logoUrl &&
                            <img className="h-5 mt-2" src={listItem.logoUrl} alt="logo" />
                        }

                    </div>
                </div>
            </label>
        </div>
    )
}

export default CheckBoxCard;
